import React from 'react';

const AWS_SNS = () => {
  return (
    <div>
      <h1>AWS_SNS</h1>
      <p>This is the AWS_SNS component.</p>
    </div>
  );
};

export default AWS_SNS;
